import { PropTypes } from "prop-types"
import classNames from "classnames"

import { useAccordionContext } from "./AccordionContext"

const AccordionSection = ({ children, id, index }) => {
  const { isOpen, isPrintable } = useAccordionContext(index)

  return (
    <div className={classNames("oj-accordion-section", { open: isOpen }, { closed: !isOpen })}>
      {isPrintable && <div className="only-print">{children}</div>}
      {isOpen && children && (
        <div className="accordion-content" id={`elements-${id}`} aria-labelledby={id} role="region">
          {children}
        </div>
      )}
    </div>
  )
}

AccordionSection.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
}

AccordionSection.displayName = "AccordionSection"

export default AccordionSection
